import { produce } from 'immer';

import { ReportWriterPayload, WorkbookWriter } from './types';

export function writeReportContent({
  writer,
  header,
  details,
  content,
  startRow,
  startColumn,
}: Omit<ReportWriterPayload, 'fileExtension'> & {
  writer: WorkbookWriter;
  startRow?: number;
  startColumn?: number;
}): WorkbookWriter {
  content.forEach((sheetContent) => {
    const sheet = writer.addWorksheet(sheetContent.sheetName, {
      startRow,
      startColumn,
    });

    if (header) {
      sheet.addHeaderSection(header);
    }

    if (details) {
      sheet.addDetailsSection(details);
    }

    if ('table' in sheetContent) {
      sheet.addTableSection(sheetContent.table);
    } else {
      sheet.addValuesSection(sheetContent.values);
    }
  });

  return writer;
}

export function formatReportWriterPayload(
  payload: ReportWriterPayload,
): ReportWriterPayload {
  return produce(payload, (draft) => {
    draft.content.forEach((sheetContent) => {
      if ('table' in sheetContent) {
        const { table } = sheetContent;
        table.headers.forEach((header) => {
          if (!header.formatter) {
            return;
          }

          table.rows.forEach((row) => {
            if (row[header.id] !== undefined && row[header.id] !== null) {
              row[header.id] = header.formatter(row[header.id]);
            }
          });
        });

        return;
      }

      if ('values' in sheetContent) {
        const { values } = sheetContent;
        values.rows.forEach((row) => {
          row.cells.forEach((cell) => {
            if (
              cell.formatter &&
              cell.value !== undefined &&
              cell.value !== null
            ) {
              cell.value = cell.formatter(cell.value);
            }
          });
        });
      }
    });
  });
}
